/**
 * Адреса обложки проекта — один модуль на сервере и клиенте. Обложка лежит на CDN Эксмо по коду ASTA;
 * её уменьшенная webp-копия — на нашем сервере (GET /api/covers/:code), полная грузится с CDN только для просмотра.
 */

const ASTA_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

/** Код ASTA, годный для адреса; null — кода нет или он не похож на код (защита URL). */
export function parseCoverCode(asta: string | null | undefined): string | null {
  const code = asta?.trim();
  return code && ASTA_PATTERN.test(code) ? code : null;
}

/** Обложка в полном размере на CDN Эксмо. */
export function coverCdnUrl(code: string): string {
  return `https://cdn.eksmo.ru/v2/${code}/COVER/cover.jpg`;
}

/** Превью обложки — путь от базы API: webp или 404, если обложки на CDN нет. */
export function coverThumbPath(code: string): string {
  return `/covers/${code}`;
}
